function ifNeq(context, options) {
  /* NOTE: Do NOT use an arrow function
   *   because we need the "this" to refer to the context of the template
   *   and arrow functions do not have the correct "this" for that purpose
   */
  if (context !== options.hash.compare) {
    return options.fn(this);
  }
  return undefined;
}

module.exports = ifNeq;



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/Polaris/header-footer-wgl/polaris_deploy_header-footer-wgl_deployable_pipeline/package/node_modules/@feature/footer/src/helpers/ifNeq.js